import '.dg{padding:12px 16px;}.ssr-plugin'
import '.cq{border-radius:24px;}.ssr-plugin'
import '.ag{box-sizing:border-box;}.ssr-plugin'
import '.dh{outline:none;}.ssr-plugin'
import '.cd{font-size:16px;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.di{cursor:pointer;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.dj{min-height:44px;}.ssr-plugin'
import '.dk{gap:10px;}.ssr-plugin'
import '.dl{transition:all 200ms ease;}.ssr-plugin'
import '.a3{margin-left:auto;}.ssr-plugin'
import { styled, Style } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'

type ButtonProps = {
  onClick?: (e?: any) => void
  style?: Style
  children: React.ReactNode
  leadIcon?: React.ReactNode
  trailIcon?: React.ReactNode
  ariaLabel?: string
  disabled?: boolean
  variant?: 'fill' | 'border' | 'ghost'
  fullWidth?: boolean
  id?: string
}

export const Button = ({
  onClick,
  style,
  children,
  leadIcon,
  trailIcon,
  ariaLabel,
  disabled,
  variant = 'fill',
  fullWidth,
  id,
}: ButtonProps) => {
  return (
    <styled.button className="dg cq ag dh cd o di v dj dk dl"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      id={id}
      style={
        {
          backgroundColor:
            variant === 'ghost'
              ? 'transparent'
              : variant === 'border'
                ? colors.border
                : colors.white,
          color:
            variant === 'border' || variant === 'ghost'
              ? colors.white
              : colors.secondary,
          border:
            variant === 'ghost'
              ? '1px solid transparent'
              : `1px solid ${colors.border}`,
          width: fullWidth ? '100%' : 'fit-content',
          backdropFilter: variant === 'border' ? 'blur(8px)' : 'none',
          WebkitBackdropFilter: variant === 'border' ? 'blur(8px)' : 'none',
          '&:hover': {
            backgroundColor: disabled
              ? ''
              : variant === 'border'
                ? transparentColor(colors.white, 0.2)
                : variant === 'fill'
                  ? transparentColor(colors.white, 0.8)
                  : transparentColor(colors.white, 0.2),
            border:
              variant === 'ghost' && !disabled
                ? `1px solid ${colors.border}`
                : undefined,
            opacity: disabled ? 0.25 : 1,
            scale: disabled ? 1 : 0.98,
          },
          '&:disabled': {
            opacity: 0.25,
            cursor: 'not-allowed',
          },
          "html[dir='rtl'] & svg": {
            transform: 'scaleX(-1)',
          },
          "html[dir='rtl'] & span": {
            marginLeft: '0',
            marginRight: 'auto',
          },
          ...style,
        } as Style
      }
    >
      {leadIcon}
      {children}
      {trailIcon && fullWidth ? (
        <span className="a3 o v"
        >
          {trailIcon}
        </span>
      ) : (
        trailIcon
      )}
    </styled.button>
  )
}
